<template>
  <div class="container">
    <div class="main-content">

      <div class="white-box">
        <div class="list order-list">
          <div class="list-title">我的订单</div>
          <div style="overflow:scroll;height: 480px">
            <ul class="list-content">
              <li v-for="item in list">
                <div class="order-info">
                  <p>
                    <i v-bind:class="['icon-fileext', 'icon-' + fileExt(item.fileName)]"></i>
                    <span class="fl fs16">{{ item.fileName }}</span>
                  </p>
                  <p>
                    <span class="gray number">￥{{ item.balancePrice/100 }}</span>
                    <span class="gray">打印配置：{{ printOption(item) }}</span>
                    <span class="fr" style="color:red;">取件码：{{ item.takeCode }}</span>
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <!--<pagination :pageCount="pageCount" v-on:togglePage="togglePage" ref="pagination" v-show="pageCount > 1"></pagination>-->
      </div>

    </div>
    <div class="main-banner">
      <user-info></user-info>
      <service></service>
    </div>
  </div>
</template>

<script>
  import {ajax} from '@/api/global'
  import Cookies from 'js-cookie'

  import UserInfo from '@/components/UserInfo'
  import Service from '@/components/Service'

  export default {
    name: "PageUser",
    components: {
      UserInfo,
      Service
    },
    props: ['isLogin'],
    data: function () {
      return {
        list : null
      }
    },
    computed: {

    },
    methods: {
      fileExt(file) {
        // console.info('filename:'+JSON.stringify(file));
        let filename = file;
        let index1=filename.lastIndexOf(".");
        let index2=filename.length;
        let type=filename.substring(index1+1,index2).toLowerCase();
        // console.info(type);
        return type;
      },
      printOption (opt) {
        // console.info(self.list);
        // console.info(opt);
        var str = "";

        if (opt.orderType=="1") {
          str+="文件 | ";
        } else if (opt.orderType=="2") {
          str+="证件 | ";
        } else if (opt.orderType=="3") {
          str+="照片 | ";
        }

        str += opt.copies + "份"

        if(opt.sideType == "1") {
          str += " | 单面";
        } else if(opt.sideType == "2") {
          str += " | 双面";
        } else {
          str += " | 横版双面";
        }
        if(opt.colorType == "2") {
          str += " | 彩色";
        } else {
          str += " | 黑白";
        }

        if(opt.paperType == "A4") {
          str += " | A4";
        } else if(opt.paperType == "A3") {
          str += " | A3";
        }

        if (opt.numbers == "1") {
          str += " | 1页/版"
        } else if (opt.numbers == "2") {
          str += " | 2页/版"
        } else if (opt.numbers == "4") {
          str += " | 4页/版"
        } else if (opt.numbers == "6") {
          str += " | 6页/版"
        }

        // opt.realPagecount = Math.ceil(parseInt(opt.copies) * opt.pageCount/parseInt(opt.numbers));

        return str;
      },
      ajaxList : function () {
        var self = this;
        ajax({
          url : 'api/app-service/getWaitPrintOrder/all',
          data : {},
          type : 'get',
          success : function (res) {
            // self.pageCount = res.totalPages;
            self.list = res.data;
          }
        });
      },
      togglePage : function (page) {
        this.page = page;
        this.ajaxList();
      },
      checkStatus : function () {
        if (this.$route.path !== '/user') {
          if (/success/.test(location.href)) {
            alert('支付成功!');
            // this.$vDialog.alert('支付成功!', null, {messageType: 'success'});
          } else if (/fail/.test(location.href)) {
            alert('支付失败, 请重试!');
            // this.$vDialog.alert('支付失败, 请重试!', null, {messageType: 'error'});
          }
          history.replaceState(null, '印箱', '/user');
          router.push('/user');
        }
      }
    },
    created: function () {
      console.info('page-user-init');
      // this.checkStatus();
      this.ajaxList();
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/PageUser.vue